import {React, FC, useContext, useScrollToRefChange} from 'external/react'

import {LocalizationProvider, styled, AdapterDayjs} from 'external/material'

import TopBar from 'planning/PlanningTopbar'
import AddDailyPlanning from './DailyPlanning/AddDailyPlanning'

import PlanificationAccordion from './components/PlanificationAcordion'
import UnitPlan from './UnitPlan'
import GeneralInfo from './GeneraInfo'

import SideBar from './SideBar'
import DailyPlanning from './DailyPlanning'
import { TeacherContext } from 'teacher/context'

const StyledPlanRD = styled('div')(planRDStyles as any)

const PlanRD: FC = () => {
    const {translate} = useContext(TeacherContext) as any
  const [lastItemRef, scrollToLastItem] = useScrollToRefChange()
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StyledPlanRD className="plan-rd">
                <TopBar className="topbar" rd={true}>
                    <AddDailyPlanning scrollToLastItem={scrollToLastItem}/>
                </TopBar>
                <div className="main">
                    <div className="content">
                        <PlanificationAccordion className="unit-planning" title={translate('planning-rd-unit-planning')} deleteButton={false}>
                            <GeneralInfo />
                            <UnitPlan />
                        </PlanificationAccordion>
                        <DailyPlanning lastItemRef={lastItemRef} />
                    </div>
                    <SideBar className="sidebar"/>
                </div>
            </StyledPlanRD>
        </LocalizationProvider>
    )
}

function planRDStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& > .topbar': {
            flexShrink: 0
        },
        '& > .main': {
            padding: '10px 20px',
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            gap: 15,
            '& > .content': {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflowY: 'auto',
                paddingRight: 10
            },
            '& > .sidebar': {
                minWidth: 310,
                maxWidth: 310,
                overflowY: 'auto',
                scrollbarWidth: 'thin'
            },
            '& .unit-planning': {
                marginBottom: 20
            }
        },
    }
}

export { PlanRD as default }